// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3kQDY","title":"Info_title__2xmqB","selects":"Info_selects__1CxIT","requiredAsterisk":"Info_requiredAsterisk__2nQkT"};